// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/schenkelfeder-fuer-bremselement-im-pkw-fensterheber/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSchenkelfederFuerBremselementImPkwFensterheberDE: PageEntry = {
  id: "example.produkte-schenkelfeder-fuer-bremselement-im-pkw-fensterheber",
  locale: "de",
  slug: "produkte/schenkelfeder-fuer-bremselement-im-pkw-fensterheber",
  seo: {
    title: "Schenkelfeder für Bremselement im PKW Fensterheber | Dietz GmbH",
    description: "Sonderwerkzeuge für kleine Biegungen und sehr hohe Genauigkeit",
  },
  type: "post",
  h1: "Schenkelfeder für Bremselement im PKW Fensterheber",
  intro: "Sonderwerkzeuge für kleine Biegungen und sehr hohe Genauigkeit",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_schenkelfeder-Bremselement.jpg", alt: "Schenkelfeder für Bremselement im PKW Fensterheber", width: 1400, height: 1120 }
  ],
};
